import { Dto, DtoWithId } from "@mango/core";
import { InstrumentDefinitie } from "./instrument-definitie";


@Dto({fullName: "CIJBorculo.Logic.InstrumentPrijsHistorie"})
export class InstrumentPrijsHistorie extends DtoWithId {
	instrumentDefinitieID: InstrumentDefinitie;
	type: string;
	prijs: number;
	datum: Date;
}